import { Link } from "react-router-dom";
import PageBanner from "../components/PageBanner";
import { EXPERTS, SITE, WHATSAPP_LINK } from "../data/siteConfig";

const About = () => {
  return (
    <div data-testid="about-page">
      <PageBanner
        crumb="About Us"
        title="About POSH Compliance"
        subtitle="A professional legal and compliance consulting firm specializing in POSH compliance, corporate governance, and regulatory advisory."
      />

      {/* Intro */}
      <section className="section" data-testid="about-intro">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6" data-aos="fade-right">
              <span className="eyebrow">Who We Are</span>
              <h2 className="section-title">
                Building Safer, <span className="accent">Compliant</span>{" "}
                Workplaces Since Day One
              </h2>
              <div className="rs-divider"></div>
              <p>
                POSH Compliances, operating under Venturemitra Compliance Manager LLP, provides expert POSH compliance, workplace safety training, and corporate advisory services for organizations across India.
              </p>
              <p>
                We help organizations create safe, inclusive, and legally
                compliant workplaces through expert training, advisory, and
                governance solutions — combining statutory precision with
                practical workplace insights.
              </p>

              <div className="row g-3 mt-4">
                <div className="col-6">
                  <div className="rs-stat" style={{ background: "#fff", borderRadius: "14px", border: "1px solid var(--rs-border)" }}>
                    <div className="num">8+</div>
                    <small>Years Experience</small>
                  </div>
                </div>
                <div className="col-6">
                  <div className="rs-stat" style={{ background: "#fff", borderRadius: "14px", border: "1px solid var(--rs-border)" }}>
                    <div className="num">50+</div>
                    <small>Clients Served</small>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6" data-aos="fade-left">
              <div className="rs-why-visual">
                <img
                  src="/images/about.png"
                  alt="Our office"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Experts Detail */}
      <section className="section section-alt" data-testid="about-experts">
        <div className="container">
          <div className="text-center mb-5" data-aos="fade-up">
            <span className="eyebrow">Our Leadership</span>
            <h2 className="section-title">Meet The Experts Behind Your Compliance</h2>
            <div className="rs-divider"></div>
          </div>

          {EXPERTS.map((e, i) => (
            <div
              className={`row align-items-center g-5 ${i !== 0 ? "mt-3" : ""}`}
              key={i}
              data-testid={`about-expert-${i}`}
            >
              <div
                className={`col-lg-5 ${i % 2 === 1 ? "order-lg-2" : ""}`}
                data-aos={i % 2 === 0 ? "fade-right" : "fade-left"}
              >
                <div
                  className="rs-why-visual"
                  style={{ aspectRatio: "4/4", maxHeight: "460px" }}
                >
                  <img src={e.image} alt={e.name} />
                </div>
              </div>
              <div
                className="col-lg-7"
                data-aos={i % 2 === 0 ? "fade-left" : "fade-right"}
              >
                <span className="rs-expert-role">{e.role}</span>
                <h3 style={{ fontSize: "1.9rem", marginTop: "6px" }}>
                  Meet {e.name}
                </h3>
                <div className="rs-divider"></div>
                <p>{e.bio}</p>
                {i === 0 && (
                  <p>
                    With over 6 years of experience, he specializes in
                    corporate compliance under the Companies Act, 2013. His
                    expertise includes mergers & acquisitions, due diligence,
                    agreement vetting, and liaisoning with ROC, MCA, and courts.
                    He is a Certified POSH Trainer and Independent Director,
                    providing governance insights and compliance solutions.
                  </p>
                )}
                {i === 1 && (
                  <p>
                    Her qualifications include LL.B., B.Com, M.Com, MBA, and
                    CS. She specializes in POSH compliance, IC advisory, and
                    training programs. She is also actively involved in NGOs
                    and conducts awareness sessions such as "Good Touch and
                    Bad Touch."
                  </p>
                )}
                <div className="rs-expert-tags mt-3">
                  {e.tags.map((t, idx) => (
                    <span key={idx} className="rs-tag">{t}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Mission */}
      <section className="section" data-testid="about-mission">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9 text-center" data-aos="fade-up">
              <span className="eyebrow">Our Mission</span>
              <h2 className="section-title">
                To Build{" "}
                <span className="accent">Safe, Respectful & Legally Compliant</span>{" "}
                Workplaces
              </h2>
              <div className="rs-divider"></div>
              <p className="section-lead mx-auto">
                Through expert training and advisory services — combining
                deep legal expertise with a practical, people-first approach.
                We believe that compliance is not a tick-box exercise; it's
                the foundation of a culture where every employee thrives.
              </p>

              <div className="row g-4 mt-4 text-start">
                {[
                  { icon: "bi-shield-check", title: "Integrity", desc: "Uncompromising professional ethics and confidentiality." },
                  { icon: "bi-people", title: "Empathy", desc: "People-first advisory that respects every stakeholder." },
                  { icon: "bi-lightbulb", title: "Expertise", desc: "Deep legal and governance knowledge, continuously updated." },
                ].map((v, i) => (
                  <div className="col-md-4" key={i}>
                    <div className="rs-card" data-aos="fade-up" data-aos-delay={i * 80}>
                      <div className="rs-icon">
                        <i className={`bi ${v.icon}`}></i>
                      </div>
                      <h5>{v.title}</h5>
                      <p>{v.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section section-alt">
        <div className="container">
          <div className="rs-cta" data-aos="zoom-in">
            <div className="row align-items-center g-4">
              <div className="col-lg-8">
                <h2>Let's Build A Safer Workplace Together</h2>
                <p>Free 30-minute consultation with our certified POSH trainers.</p>
              </div>
              <div className="col-lg-4">
                <div className="rs-cta-actions">
                  <Link to="/contact" className="btn btn-rs-accent">
                    Book Consultation <i className="bi bi-arrow-right"></i>
                  </Link>
                  <a
                    href={WHATSAPP_LINK}
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-rs-ghost"
                  >
                    <i className="bi bi-whatsapp"></i> WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
